module.exports = __webpack_public_path__ + "static/media/what-matters-most-two.d73d5505.png";